/* eslint-disable no-nested-ternary */
import CardWithTitle from 'components/CardWithTitle';
import InfoCard from 'components/InfoCard';
import React from 'react';
import { NumberWithCommasFormat } from 'utils/constants';
import { Col, Label, Row } from 'reactstrap';
import BidsInfoDetail from '../BidsInfoDetail';
import OrderInfoDetail from '../OrderInfoDetail';
import ProductInfoDetail from '../ProductInfoDetail';
import FavouritedUsersDetail from '../FavouritedUsersDetail';

const ForeignOfferDetails = ({ row, type }) => {
  const {
    createdAt,
    acceptedBids,
    rejectedBids,
    totalOrders,
    deliveredOrders,
  } = row;
  const gradeId = row?.grade?.id || row?.grades?.[0]?.id;

  return (
    <Row>
      <Col sm={9}>
        <InfoCard
          offerId={row?.id}
          gradeName={
            row?.grade
              ? row?.grade?.name
              : row?.grades.length
                ? row?.grades[0]?.name
                : '-'
          }
          category={
            row?.grade
              ? row.grade.category?.name
              : row?.grades.length
                ? row?.grades[0]?.name
                : '-'
          }
          rate={`$${row?.rate}`}
          createDate={createdAt}
          validity={row?.validityInHours}
        />

        <CardWithTitle title="Other Details">
          <div className="order-status border rounded-8 p-3 mt-2 mb-3">
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Offer Type</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {row[type]}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Packaging type</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {row?.packagingTypeId?.type}
                  {row?.packagingType?.type}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Minimum order quantity</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {NumberWithCommasFormat(row?.minimumQty)}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Total quantity</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {NumberWithCommasFormat(row?.totalQty)}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Location</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {row?.state?.stateName}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Payment Terms</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Label className="f-12 fw-medium">Source</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
          </div>
          <div className="order-status border rounded-8 p-3 mt-2 mb-3">
            <h4 className="text-uppercase f-12 fw-medium mb-2">Shipment</h4>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Port Of Loading</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Port Of Discharge</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Expected Date </Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Label className="f-12 fw-medium">Charges</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
          </div>
          <div className="order-status border rounded-8 p-3 mt-2 mb-3">
            <h4 className="text-uppercase f-12 fw-medium mb-2">Delivery</h4>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Terms Of Delivery</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Label className="f-12 fw-medium">Delivery Time</Label>
              </Col>
              <Col sm={4}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
          </div>
        </CardWithTitle>

        <BidsInfoDetail
          row={row}
          acceptedBids={acceptedBids}
          rejectedBids={rejectedBids}
        />
        <OrderInfoDetail
          deliveredOrders={deliveredOrders}
          totalOrders={totalOrders}
        />
        <FavouritedUsersDetail gradeId={gradeId} />
      </Col>

      <Col sm={3}>
        <ProductInfoDetail
          sellerName={`
                    ${row?.trader?.firstName} ${row?.trader?.lastName}
                    `}
          name={row?.grade?.name}
          offerType={row?.offerType}
          type={type}
        />
      </Col>
    </Row>
  );
};

export default ForeignOfferDetails;
